import React from "react";
import ProjectTools from "../../../components/ProjectTools";

export default props => {
  return (
    <div id="main" className="wrapper style1">
      <div className="container">
        <header className="major">
          <h2> {props.name || "Project Name"}</h2>
          <p>
            {props.description ||
              "Project Description"}
          </p>
          <small style={{ display: "block" }}>
            Click image to visit Project
          </small>
        </header>

        <section id="content">
          <a href={props.projectLink} className="image fit" target={'blank'} >
            {/*<img src={props.image} alt="image" />*/}
            <div style={{backgroundImage: `url(${props.image})`,
              height: '600px',backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat'}} >
            </div>
          </a>
          <h3>Tech Stack </h3>

          {/*Tech Stack takes and array */}
          <ul>
          {
            props.techStack.map((tech, i)=>{
              return <li key={i}>{tech.charAt(0).toUpperCase() + tech.slice(1)}</li>
            })
          }
          </ul>
          <h3> Project Summary</h3>
          <p>{props.description || "Project description"}</p>
          <h4>About this Project</h4>
          <p>{props.fullDescription || "full description"}</p>
          <h3>Tools </h3>
          {/*Project tools*/}
          {props.children}
        </section>
      </div>
    </div>
  );
};
